module.exports = __webpack_public_path__ + "static/media/20.c155783b.jpg";